var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11561_43164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 0.75C28.3031 0.75 36.25 8.69695 36.25 18.5C36.25 28.3031 28.3031 36.25 18.5 36.25C14.7656 36.25 11.3025 35.0974 8.44434 33.1289C7.90332 32.7564 7.18356 32.6947 6.58105 33.0225L1.5127 35.7793C1.44489 35.8161 1.39395 35.8181 1.35547 35.8115C1.31094 35.8039 1.26147 35.7801 1.21875 35.7383C1.176 35.6964 1.15113 35.647 1.14258 35.6025C1.13521 35.5641 1.13624 35.513 1.17188 35.4443L3.88184 30.2236C4.18881 29.6322 4.12533 28.9357 3.76855 28.4062C1.86225 25.5772 0.75 22.1695 0.75 18.5C0.75 8.69695 8.69695 0.75 18.5 0.75Z",
    stroke: "url(#paint0_linear_11561_43164)",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4094 8.11C18.8601 8.11 19.2501 8.27467 19.5794 8.604C19.9087 8.93333 20.0734 9.32333 20.0734 9.774C20.0734 10.2247 19.9087 10.6147 19.5794 10.944C19.2501 11.2733 18.8601 11.438 18.4094 11.438C17.9587 11.438 17.5687 11.2733 17.2394 10.944C16.9101 10.6147 16.7454 10.2247 16.7454 9.774C16.7454 9.32333 16.9101 8.93333 17.2394 8.604C17.5687 8.27467 17.9587 8.11 18.4094 8.11ZM19.7614 14.324V25.582C19.7614 26.31 19.9087 26.804 20.2034 27.064C20.5154 27.324 21.0267 27.454 21.7374 27.454V28C21.4427 27.9827 20.9921 27.9653 20.3854 27.948C19.7961 27.9133 19.1981 27.896 18.5914 27.896C18.0021 27.896 17.4041 27.9133 16.7974 27.948C16.1907 27.9653 15.7401 27.9827 15.4454 28V27.454C16.1561 27.454 16.6587 27.324 16.9534 27.064C17.2654 26.804 17.4214 26.31 17.4214 25.582V17.444C17.4214 16.664 17.2827 16.092 17.0054 15.728C16.7281 15.3467 16.2081 15.156 15.4454 15.156V14.61C16.0001 14.662 16.5374 14.688 17.0574 14.688C17.5601 14.688 18.0367 14.662 18.4874 14.61C18.9554 14.5407 19.3801 14.4453 19.7614 14.324Z",
    fill: "url(#paint1_linear_11561_43164)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11561_43164",
    x1: -7.38611,
    y1: 78.85,
    x2: -43.1746,
    y2: 48.6684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E827D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11561_43164",
    x1: -6.21806,
    y1: 72.625,
    x2: -39.4415,
    y2: 43.0054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E827D9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11561_43164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.3c21150f9b6ffcfb248031140f33a8fd.svg";
export { ForwardRef as ReactComponent };